import React from "react";
import { Component } from "react";
import pin from "views/profile/img/pin.png";
import imgdetails from "views/profile/img/timeline/imgdetails.png";
import { Chrono } from "react-chrono";
import pdf from "views/profile/img/timeline/pdf.png";
import applyjob from "views/profile/img/myjobs/applyjob.png";
import { ChevronRight, ChevronLeft, Eye } from "react-feather";
import view from "views/profile/img/view.svg";
import interview from "views/profile/img/myjobs/interview.png";
import result from "views/profile/img/myjobs/result.png";
import selection from "views/profile/img/myjobs/selection.png";
import { connect } from "react-redux";
import { getSingleJobAction, getapplicationSummary } from "store/SingleJob";
import { getApplicantHistory } from "store/Profile";

import relationshipbanner from "views/job-details/img/relationship-img.png";
class JobsList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isShowDetails: true,
      currentSelectedJob: "",
      currentJOBSummary:null
    };
  }
  async componentDidMount() {
    let ApplicationSummary = await this.props.getapplicationSummary(
      this.props.Auth.HCID
    );
  }
  async getCurrentJobJSON(val) {
    this.setState({
      isShowDetails: !this.state.isShowDetails,
    });
    let response = await this.props.getSingleJobAction(val.RID);
    this.setState({ currentSelectedJob: val });
    let ResponseSummary=await this.props.getApplicantHistory(val.RID);
    this.setState({currentJOBSummary:ResponseSummary})
    // console.log(ResponseSummary);
  }
  addDefaultSrc(ev) {
    ev.target.src = relationshipbanner;
  }
  dateFormat(date){
return new Date(date).toDateString()
  }
  render() {
    const getStatusClass = (val) => {
      const { status } = val;
      if (status == "Shortlisted") {
        return "chips-success";
      }
      if (status == "Applied") {
        return "chips-success";
      }
      if (status == "Rejected") {
        return "chips-danger";
      }
      if (status == "Pending") {
        return "chips-warning";
      }
      return "";
    };
    return (
      <card className="rounded-12px drop-shadow20 bg-white block lg:p-8 md:p-8 p-5 mt-4">
        <div className="flex justify-end items-center">
          <p className="text898989 fsize14 pr-8">1 out of 3</p>
          <div className="flex ">
            <ChevronLeft
              width="30px"
              height="30px"
              className="trend-left-i mr-2"
            />
            <ChevronRight
              width="30px"
              height="30px"
              className="trend-right-i"
            />
          </div>
        </div>
        <div className="lg:flex md:flex lg:px-12 md:px-12 pb-6">
          <div className="flex lg:justify-center w-full ">
            {this.state.isShowDetails && (
              <div className="w-full">
                <div className=" flex mt-8 justify-between items-center">
                  <div className="w-4/5 flex ">
                    <div className="w-2/5">
                      <div>
                        <p className="text898989 fsize14 ">Jobs Title</p>
                      </div>
                    </div>
                    <div className="w-1/4 text-center pl-4 mob-hidden">
                      <p className="text898989 fsize14 ">Location</p>
                    </div>
                    <div className="w-1/3 pl-4 mob-hidden">
                      <p className="text898989 fsize14 ">Date</p>
                    </div>
                  </div>
                  <div className="w-1/5">
                    {" "}
                    <div className="flex items-center ">
                      <div className="">
                        <p className="text898989 fsize14 ">Status</p>
                      </div>
                    </div>
                  </div>
                </div>
                {this.props.ApplicationSummary
                  ? this.props.ApplicationSummary.Data.JobsData.length > 0
                    ? this.props.ApplicationSummary.Data.JobsData.map(
                        (val, index) => {
                          return (
                            <div>
                              <div className=" flex mt-6 justify-between">
                                <div className="lg:w-4/5 md:w-4/5 w-9/12	">
                                  <div className="w-full lg:flex md:flex lg:items-center md:items-center lg:justify-between md:justify-between">
                                    <div className="h-full lg:w-2/5 md:w-2/5	 flex items-center">
                                      <h1 className="fsize16 text-black lg:font-medium md:font-medium font-semibold">
                                        {val.JobTitle}
                                      </h1>
                                    </div>
                                    <div className="lg:w-1/4 md:w-1/4 lg:text-center md:text-center">
                                      <h1 className="fsize14 text-black sm-text525252">
                                        {val.Location}
                                      </h1>
                                    </div>
                                    <div className="lg:w-1/3 md:w-1/3 lg:pt-0 md:pt-0 pt-1">
                                      <h1 className="fsize14 text-black sm-text525252">
                                        {val.JobAppliedDate}
                                        <span className="text898989 pl-2">
                                          {" "}
                                          {/* {val.time} */}
                                        </span>
                                      </h1>
                                    </div>
                                  </div>
                                </div>
                                <div className="lg:w-1/5 md:1/5 w-1/4	">
                                  {" "}
                                  <div
                                    className="flex items-center justify-between"
                                    onClick={() => this.getCurrentJobJSON(val)}
                                  >
                                    <div>
                                      <h1
                                        className={
                                          "fsize11 chips-success-box flex justify-center items-center  uppercase font-semibold " +
                                          getStatusClass(val)
                                        }
                                      >
                                        {val.Status}
                                      </h1>
                                    </div>
                                    <div className="mob-hidden">
                                      <div className="cursor-pointer">
                                        <img src={view} />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="border-bE0E0E0 pt-3"> </div>
                            </div>
                          );
                        }
                      )
                    : ""
                  : ""}
              </div>
            )}
            {!this.state.isShowDetails && (
              <div className="lg:w-11/12 md:w-11/12 w-full mt-8">
                <card className="rounded-sm drop-shadow20 bg-white block lg:p-8 md:p-8 p-4">
                  <div>
                    <div className=" ">
                      <div className="lg:flex md:flex px-4">
                        <div className="lg:w-1/2 md:w-1/2 lg:pr-4 md:pr-4">
                          <card className="rounded-sm   block ">
                            <div className="flex justify-between">
                              <p className="text-black font-bold fsize16 mb-3">
                                {/* {this.props.previewjob
                                  ? this.props.previewjob.Data?this.props.previewjob.Data.length > 0
                                    ? this.props.previewjob.Data[0].JobTitle
                                    : "":""
                                  : ""} */}
                                  {this.state.currentSelectedJob.JobTitle}
                              </p>
                              <h1 className="fsize11 chips-success-box  chips-success flex justify-center items-center  uppercase font-semibold">
                                {this.state.currentSelectedJob.Status}
                              </h1>
                            </div>
                            {
                             this.props.previewjob ? this.props.previewjob.Data?this.props.previewjob.Data.length>0?
                            <div>
                              <div className="flex justify-between items-center mt-2  mb-6">
                                <div className="flex items-center justify-between w-full">
                                  <div className="lg:flex md:flex items-center">
                                    <div className="flex items-center">
                                      <img src={pin} alt="map" />
                                      <p className="text074A7F fsize14 ml-2">
                                        {this.props.previewjob
                                          ?this.props.previewjob.Data? this.props.previewjob.Data.length >
                                            0
                                            ? this.props.previewjob.Data[0]
                                                .Location
                                            : "":""
                                          : ""}
                                      </p>
                                    </div>

                                    <p className="text-black opacity-50 fsize14 lg:pl-8 md:pl-8">
                                      3d ago
                                    </p>
                                  </div>

                                  <div className="lg:flex md:flex items-center">
                                    <p className="text3C3C3C fsize14">
                                      20th Jun 2021
                                    </p>
                                    <p className="text-black fsize14 opacity-50 lg:pl-4 md:pl-4">
                                      {" "}
                                      11:49 AM
                                    </p>
                                  </div>
                                </div>
                              </div>{" "}
                              <p className="text-black fsize12 line-clamp-3 line-h20px">
                                {this.props.previewjob
                                  ? this.props.previewjob.Data ?this.props.previewjob.Data.length > 0
                                    ? this.props.previewjob.Data[0]
                                        .f_short_description
                                    : "":""
                                  : ""}
                              </p>
                              <div className="chips flex justify-between mt-10 lg:w-4/6 md:w-4/6 mb-4 ">
                                <div className="bgE77820-trans rounded-21px p-10-17px">
                                  <p className="fsize11 opacity-100 textF06321 font-semibold">
                                    {this.props.previewjob
                                      ?this.props.previewjob.Data? this.props.previewjob.Data.length > 0
                                        ? this.props.previewjob.Data[0].JobType
                                        : "":""
                                      : ""}
                                  </p>
                                </div>
                                <div className="bgE77820-trans rounded-21px p-10-17px ">
                                  <p className="fsize11 font-semibold opacity-100 textF06321">
                                    {this.props.previewjob
                                      ?this.props.previewjob.Data? this.props.previewjob.Data.length > 0
                                        ? this.props.previewjob.Data[0]
                                            .Experience
                                        : "":""
                                      : ""}
                                  </p>
                                </div>

                                <div className="bgE77820-trans rounded-21px p-10-17px">
                                  <p className="fsize11 font-semibold opacity-100 textF06321">
                                    {this.props.previewjob
                                      ?this.props.previewjob.Data? this.props.previewjob.Data.length > 0
                                        ? this.props.previewjob.Data[0].Function
                                        : "Function":""
                                      : "Function"}
                                  </p>
                                </div>
                              </div>
                            </div>
                         
                         
                         : "":""
                         : ""
                      }
                         </card>
                        </div>

                        <div className="lg:w-1/2 md:w-1/2">
                          <p
                            className="textE77817 underline cursor-pointer text-right font-semibold fsize12 mb-4"
                            onClick={() =>
                              this.setState({
                                isShowDetails: !this.state.isShowDetails,
                              })
                            }
                          >
                            Hide Details
                          </p>
                          {
                             this.props.previewjob ? this.props.previewjob.Data?this.props.previewjob.Data.length>0?
                             <div className="flex justify-end">
                            <img
                              onError={this.addDefaultSrc}
                              src={
                                process.env.REACT_APP_IMAGE_BASE_MG +
                                "" +
                                this.props.previewjob
                                  ? this.props.previewjob.Data?this.props.previewjob.Data.length>0
                                    ? process.env.REACT_APP_IMAGE_BASE_MG +
                                      "" +
                                      this.props.previewjob.Data[0].f_path
                                    : "":""
                                  : ""
                              }
                              alt="relationshipbanner"
                              className="w-357px h-228px"
                            />

                         
                          </div>
                      
                               : "":""
                             : ""
                          }
                      
                        </div>
                      </div>

                      {/* <div className="">
                        <p className="text898989 fsize14">Attachments</p>
                        <div className="flex items-center mt-4">
                          <img src={pdf} alt="pdf" className="w-20px h-27px" />
                          <p className="text-black fsize16 font-semibold pl-3">
                            Resume.pdf
                          </p>
                        </div>
                      </div> */}

                      <div className="mt-16">
                        <div className="w-5/6	m-auto border-t-053C6D">
                          <div className="lg:flex md:flex justify-between">
                            {this.state.currentJOBSummary?this.state.currentJOBSummary.ResponseCode==100?this.state.currentJOBSummary.Data.map((value,index)=>{
                              return(

                                <div className="lg:w-1/4  md:w-1/4 w-full py-3 px-3 relative" key={index}>
                                <div className="flex mt-4">
                                  <div className="w-1/4  timeline-rad flex justify-center  ">
                                    <img
                                      src={applyjob}
                                      alt="image1"
                                      className="w-33px h-33px"
                                    />
                                  </div>
                                  <div className="absolute top-0 left-38per	 ">
                                    <p className="v-border"></p>
                                  </div>
  
                                  <div className="pl-3">
                                    <p className="text-black opacity-80 fsize14">
                                     {value.StatusTitle}
                                    </p>
                                    <p className="text7F7F7F opacity-75 fsize12">
                                    {this.dateFormat(value.ModifiedDate)}
                                    </p>
                                  </div>
                                </div>
                              </div>
  
                              )
                            }):"":""}
{/*                       
                            <div className="lg:w-1/4  md:w-1/4 w-full py-3 px-3 relative">
                              <div className="flex mt-4">
                                <div className="w-1/4  timeline-rad flex justify-center  ">
                                  <img
                                    src={result}
                                    alt="image1"
                                    className="w-33px h-33px"
                                  />
                                </div>
                                <div className="absolute top-0 left-38per	 ">
                                  <p className="v-border"></p>
                                </div>

                                <div className="pl-3">
                                  <p className="text-black opacity-80 fsize14">
                                    Result
                                  </p>
                                  <p className="text7F7F7F opacity-75 fsize12">
                                    24th Jun 2021
                                  </p>
                                </div>
                              </div>
                            </div>

                            <div className="lg:w-1/4  md:w-1/4 w-full py-3 px-3 relative">
                              <div className="flex mt-4">
                                <div className="w-1/4  timeline-rad flex justify-center  ">
                                  <img
                                    src={interview}
                                    alt="image1"
                                    className="w-33px h-33px"
                                  />
                                </div>
                                <div className="absolute top-0 left-38per	 ">
                                  <p className="v-border"></p>
                                </div>

                                <div className="pl-3">
                                  <p className="text-black opacity-80 fsize14">
                                    Interview
                                  </p>
                                  <p className="text7F7F7F opacity-75 fsize12">
                                    25th Jun 2021
                                  </p>
                                </div>
                              </div>
                            </div>

                            <div className="lg:w-1/4  md:w-1/4 w-full py-3 px-3 relative">
                              <div className="flex mt-4">
                                <div className="w-1/4  timeline-rad flex justify-center  ">
                                  <img
                                    src={selection}
                                    alt="image1"
                                    className="w-33px h-33px"
                                  />
                                </div>
                                <div className="absolute top-0 left-38per	 ">
                                  <p className="v-border"></p>
                                </div>

                                <div className="pl-3">
                                  <p className="text-black opacity-80 fsize14">
                                    Selection
                                  </p>
                                  <p className="text7F7F7F opacity-75 fsize12">
                                    27th Jun 2021
                                  </p>
                                </div>
                              </div>
                            </div>
                       */}
                      
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </card>
              </div>
            )}
          </div>
        </div>
      </card>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    Auth: state.Auth.user,
    ApplicationSummary: state.SingleJob.home.APPLICATIONSUMMARY,
    previewjob: state.SingleJob.home.CURRENTJOB,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getapplicationSummary: async (payload) =>
      await dispatch(getapplicationSummary(payload)),
    getSingleJobAction: async (payload) =>
      await dispatch(getSingleJobAction(payload)),
      getApplicantHistory: async (payload) =>
      await dispatch(getApplicantHistory(payload)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(JobsList);
